var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWorksFigNobg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 639.9,
    height: 682.4,
    viewBox: "0 0 639.9 682.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.2,523.2l1.3-22.8a3.9,3.9,0,0,0,2.1,3.1l-1.3,22.8C145.8,525.4,145.1,524.3,145.2,523.2Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M463.8,574.9l-1.3,22.8a3,3,0,0,1-1.4,2.3l1.3-22.8A3.1,3.1,0,0,0,463.8,574.9Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M380.7,635.3l-1.3,22.8a7.6,7.6,0,0,1-5.1,1.2,8.1,8.1,0,0,1-3.3-1.1l1.3-22.8a8,8,0,0,0,3.4,1.1A7.5,7.5,0,0,0,380.7,635.3Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.3,11.1l20,.4a7.4,7.4,0,0,1,3,.8l-20.1-.4A6,6,0,0,0,137.3,11.1Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M552.9,612.4l-20.1-.5c4.7.2,9.1-5.4,10.7-14.2l20.1.5C562,606.9,557.6,612.5,552.9,612.4Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M591.7,262.2l20.1.4c5.6,3.2,8.7,14.2,6.8,24.8l-20-.5C600.4,276.4,597.4,265.3,591.7,262.2Z",
    style: {
      fill: "none"
    }
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard 12") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_11",
    "data-name": "Layer 11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_9",
    "data-name": "Layer 9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "disp"
  }, /*#__PURE__*/React.createElement("g", {
    id: "standbase"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.6,503.5l-1.3,22.8a3.5,3.5,0,0,1-2.1-2.9l1.3-22.8a4.1,4.1,0,0,0,2.1,2.9",
    style: {
      fill: "#153852"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.5,500.6l-1.3,22.8v-.2l1.3-22.8v.2",
    style: {
      fill: "#13334b"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M463.8,574.9l-1.3,22.8a3,3,0,0,1-1.4,2.3l1.3-22.8a3.1,3.1,0,0,0,1.4-2.3",
    style: {
      fill: "#13334b"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "462.4 577.2 461.1 600 379.4 658.1 380.7 635.3 462.4 577.2",
    style: {
      fill: "#122f44"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.3 635.4 371 658.2 147.3 526.3 148.6 503.5 372.3 635.4",
    style: {
      fill: "#163b57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.7,438.8a8.3,8.3,0,0,1,3.4,1l223.7,132c2.5,1.4,2.7,3.9.6,5.4l-81.7,58.1a7.5,7.5,0,0,1-5,1.2,8,8,0,0,1-3.4-1.1L148.6,503.5c-2.5-1.5-2.8-3.9-.6-5.5l81.7-58.1A7.7,7.7,0,0,1,234.7,438.8Z",
    style: {
      fill: "#19405e"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-3)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M380.7,635.3l-1.3,22.8a7.6,7.6,0,0,1-4.6,1.2l1.3-22.8a7.6,7.6,0,0,0,4.6-1.2",
    style: {
      fill: "#13334b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.1,636.5l-1.3,22.8h-.4a7.9,7.9,0,0,1-3.4-1l1.3-22.9a8,8,0,0,0,3.4,1.1h.4",
    style: {
      fill: "#153852"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "stand"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "381.3 472.7 379.1 594.4 227.2 513.7 229.4 392 381.3 472.7",
    style: {
      fill: "#173c57"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "381.3 472.7 396 469.1 393.9 590.8 379.1 594.4 381.3 472.7",
    style: {
      fill: "#14344c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "229.4 392 244.1 388.4 396 469.1 381.3 472.7 229.4 392",
    style: {
      fill: "#173e5a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "dispaly"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-4)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.3,11.1l20,.4a6.8,6.8,0,0,1,2.7.7l-20.1-.5a5.8,5.8,0,0,0-2.6-.6",
    style: {
      fill: "#13334b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.9,11.7l20.1.5h.3l-20.1-.4-.3-.2",
    style: {
      fill: "#14364f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-5)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M543.5,597.8l20.1.4c-1.6,8.7-6,14.3-10.7,14.2l-20.1-.4c4.7.1,9.1-5.5,10.7-14.2",
    style: {
      fill: "#123147"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "140.2 11.9 160.3 12.3 611.8 262.6 591.7 262.2 140.2 11.9",
    style: {
      fill: "#14354d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "598.6 286.9 618.6 287.4 563.6 598.2 543.5 597.7 598.6 286.9",
    style: {
      fill: "#133148"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.7,262.2c5.7,3.1,8.7,14.2,6.9,24.7L543.5,597.8c-1.9,10.5-8,16.5-13.6,13.3L78.4,360.8c-5.7-3.1-8.7-14.2-6.9-24.7L126.6,25.3c1.9-10.6,7.9-16.5,13.6-13.4Z",
    style: {
      fill: "#194362"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-6)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M591.7,262.2l20.1.4c2.8,1.6,4.9,5.1,6.2,9.5l-20.1-.5c-1.2-4.4-3.4-7.9-6.2-9.4",
    style: {
      fill: "#14364f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.9,271.6l20.1.5a31.5,31.5,0,0,1,1.2,8.7l-20.1-.5a32,32,0,0,0-1.2-8.7",
    style: {
      fill: "#13334b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.1,280.3l20.1.5a36.8,36.8,0,0,1-.6,6.6l-20-.5a48.9,48.9,0,0,0,.5-6.6",
    style: {
      fill: "#123147"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "dis"
  }, /*#__PURE__*/React.createElement("path", {
    id: "DISPALY_CONTENT",
    "data-name": "DISPALY CONTENT",
    d: "M516.4,579.9,94.7,342.2a7.9,7.9,0,0,1-3.9-8.2L139,45.4a8,8,0,0,1,9.2-6.5,6.2,6.2,0,0,1,2.6.9L572.4,277.5a8.2,8.2,0,0,1,4,8.3L528.1,574.3a8,8,0,0,1-9.2,6.6A7.7,7.7,0,0,1,516.4,579.9Z",
    style: {
      fill: "#dcf0ff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "disp_contetn",
    "data-name": "disp contetn"
  }, /*#__PURE__*/React.createElement("path", {
    id: "DISPALY_CONTENT-2",
    "data-name": "DISPALY CONTENT-2",
    d: "M474.9,556.1,128.4,360.7a6,6,0,0,1-3-6.3L176.1,91.9a5.9,5.9,0,0,1,6.9-4.8l1.9.7L531.4,283.2a6,6,0,0,1,2.9,6.3L483.7,552a5.9,5.9,0,0,1-6.9,4.8Z",
    style: {
      fill: "#71a0bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "DISPALY_CONTENT-3",
    "data-name": "DISPALY CONTENT-3",
    d: "M316.9,458.2,154.1,366.4a6,6,0,0,1-3-6.3l35-190.7a6,6,0,0,1,6.9-4.8,6.2,6.2,0,0,1,1.9.7l162.8,91.8a6,6,0,0,1,2.9,6.3L325.7,454.1a6,6,0,0,1-6.9,4.8A4.4,4.4,0,0,1,316.9,458.2Z",
    style: {
      fill: "#3a6689"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "DISPALY_CONTENT-4",
    "data-name": "DISPALY CONTENT-4",
    d: "M455.2,536.3,346.8,475.2a5.8,5.8,0,0,1-2.9-6.3l34.8-190.7a6,6,0,0,1,7-4.8,6.4,6.4,0,0,1,1.8.6l108.4,61.1a6,6,0,0,1,2.9,6.3L464,532.2a5.9,5.9,0,0,1-6.9,4.8A4.4,4.4,0,0,1,455.2,536.3Z",
    style: {
      fill: "#3a6689"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "DISPALY_CONTENT-5",
    "data-name": "DISPALY CONTENT-5",
    d: "M521.8,325.6,172.9,128.1a3.9,3.9,0,0,1-1.9-4.2l6.3-34.7a4,4,0,0,1,4.6-3.2l1.3.5L532.1,284a3.7,3.7,0,0,1,1.9,4.1l-6.3,34.8a4,4,0,0,1-4.6,3.2Z",
    style: {
      fill: "#1a6691"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "DISPALY_CONTENT-6",
    "data-name": "DISPALY CONTENT-6",
    d: "M298.5,419.6,177.2,351.2a5.8,5.8,0,0,1-2.9-6.4l11.5-54.6a6,6,0,0,1,7.1-4.6,5.1,5.1,0,0,1,1.7.7l121.3,68.3a6.2,6.2,0,0,1,2.9,6.5l-11.6,54.5a5.8,5.8,0,0,1-7,4.6A4.9,4.9,0,0,1,298.5,419.6Z",
    style: {
      fill: "#1b435e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "DISPALY_CONTENT-7",
    "data-name": "DISPALY CONTENT-7",
    d: "M439,511.7l-77.5-43.6a6.2,6.2,0,0,1-2.9-6.5l11.2-52.4a5.9,5.9,0,0,1,7-4.7l1.8.7L456,448.8a6.2,6.2,0,0,1,2.9,6.5l-11.2,52.4a5.9,5.9,0,0,1-7,4.7Z",
    style: {
      fill: "#1b435e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "DISPALY_CONTENT-8",
    "data-name": "DISPALY CONTENT-8",
    d: "M326.1,278.8,204.5,210.3a5.9,5.9,0,0,1-2.8-6.4h0a5.9,5.9,0,0,1,7-4.4l1.5.6,121.6,68.6a5.7,5.7,0,0,1,2.8,6.3h0a5.8,5.8,0,0,1-7,4.4A4.7,4.7,0,0,1,326.1,278.8Z",
    style: {
      fill: "#1b435e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "DISPALY_CONTENT-9",
    "data-name": "DISPALY CONTENT-9",
    d: "M331.3,301.5h0a5.9,5.9,0,0,1-7,4.4l-1.5-.6L201.3,236.7a5.8,5.8,0,0,1-2.9-6.3h0a5.9,5.9,0,0,1,7-4.4,4.4,4.4,0,0,1,1.6.6l121.5,68.5A5.8,5.8,0,0,1,331.3,301.5Z",
    style: {
      fill: "#1b435e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "DISPALY_CONTENT-10",
    "data-name": "DISPALY CONTENT-10",
    d: "M327.2,328.1h0a5.8,5.8,0,0,1-7,4.4,5.2,5.2,0,0,1-1.6-.6L197.1,263.4a5.9,5.9,0,0,1-2.8-6.4h0a5.7,5.7,0,0,1,7-4.3l1.5.6,121.5,68.5A5.8,5.8,0,0,1,327.2,328.1Z",
    style: {
      fill: "#1b435e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "DISPALY_CONTENT-11",
    "data-name": "DISPALY CONTENT-11",
    d: "M469.7,357.1l-78.6-44.3a5.3,5.3,0,0,1-2.6-5.6h0a5.3,5.3,0,0,1,6.3-4.2,4.7,4.7,0,0,1,1.5.6l78.6,44.3a5.2,5.2,0,0,1,2.6,5.6h0a5.2,5.2,0,0,1-6.2,4.2A4.4,4.4,0,0,1,469.7,357.1Z",
    style: {
      fill: "#1b435e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "DISPALY_CONTENT-12",
    "data-name": "DISPALY CONTENT-12",
    d: "M465.5,383.1l-78.6-44.3a5.3,5.3,0,0,1-2.6-5.6h0a5.3,5.3,0,0,1,6.2-4.2,4.4,4.4,0,0,1,1.6.6l78.6,44.3a5.2,5.2,0,0,1,2.6,5.6h0a5.2,5.2,0,0,1-6.2,4.2A4.4,4.4,0,0,1,465.5,383.1Z",
    style: {
      fill: "#1b435e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "DISPALY_CONTENT-13",
    "data-name": "DISPALY CONTENT-13",
    d: "M460.4,408.6l-78.6-44.3a5.3,5.3,0,0,1-2.6-5.6h0a5.3,5.3,0,0,1,6.3-4.2,5.2,5.2,0,0,1,1.6.6l78.5,44.3a5.2,5.2,0,0,1,2.6,5.6h0a5.3,5.3,0,0,1-7.8,3.6Z",
    style: {
      fill: "#1b435e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "DISPALY_CONTENT-14",
    "data-name": "DISPALY CONTENT-14",
    d: "M456.1,433.7l-78.6-44.3a5.2,5.2,0,0,1-2.6-5.7h0a5.3,5.3,0,0,1,6.2-4.2l1.6.6,78.6,44.3a5.5,5.5,0,0,1,2.6,5.7h0a5.4,5.4,0,0,1-6.3,4.2A4.7,4.7,0,0,1,456.1,433.7Z",
    style: {
      fill: "#1b435e"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "ledder"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.9,275h0a6,6,0,0,1,4.2,7.2L22.7,569.4a6,6,0,0,1-7.2,4.1h0a5.9,5.9,0,0,1-4.1-7.2L88.8,279.2A5.8,5.8,0,0,1,95.9,275Z",
    style: {
      fill: "#6e8ea0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.5,
    y: 327.8,
    width: 11.7,
    height: 84.72,
    rx: 4.5,
    transform: "translate(-274.4 345) rotate(-69.5)",
    style: {
      fill: "#6e8ea0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.7,
    y: 381.8,
    width: 11.7,
    height: 84.72,
    rx: 4.5,
    transform: "translate(-336.6 363.6) rotate(-69.5)",
    style: {
      fill: "#6e8ea0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.4,
    y: 434.3,
    width: 11.7,
    height: 84.72,
    rx: 4.5,
    transform: "translate(-393.7 386.2) rotate(-69.5)",
    style: {
      fill: "#6e8ea0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.8,
    y: 490.3,
    width: 11.7,
    height: 84.72,
    rx: 4.5,
    transform: "translate(-456.4 408) rotate(-69.5)",
    style: {
      fill: "#6e8ea0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "man"
  }, /*#__PURE__*/React.createElement("path", {
    id: "shoe_right",
    "data-name": "shoe right",
    d: "M84.2,553.9c7.6-1.5,10.9-4.1,17-3.4s6.9-6,10.1-8.2c5.3-3.5,12.3-6,15.3-9.6,6.2-7.4,3-12.9-2.1-11.7-13.7,3.4-13.6,6.9-17.7,5.7-1.3-.3-3.4,5.9-5.3,6.1a143.3,143.3,0,0,0-20.7,4.1Z",
    style: {
      fill: "#0c2030"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "shoe_left",
    "data-name": "shoe left",
    d: "M49.6,508.7c-2,1.5-3.8,7.6-4.3,10.1-1.2,6.7-.9,11.4.8,11.4s10.5-2.2,16.8-8.8,10.3-8.4,13.2-15.7c11.6-29.4,5.2-25.4-7.6-12.9Z",
    style: {
      fill: "#0c2030"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "pants",
    d: "M80.8,530.4a7.4,7.4,0,0,0,4.2,7,17.1,17.1,0,0,0,7.1,1.5c5.7,0,13.4,0,15.3-2s2-28.7,2-38.3,3.8-28.8,3.8-36.5,5.8-34.5,7.7-48,1.9-34.5,1.9-53.7-57.6-32.6-59.5-23.1-7.7,15.4-3.8,44.2c1,7.6,0,19.2,0,28.8s-2,13.4-3.9,19.2-3.8,17.3-5.7,28.8S48,485.1,48,492.8,44.1,512,51.8,512c0,0,7.7,0,11.5-1.9S71,490.9,71,490.9c0-23.1,3.8-42.2,3.8-44.2s5.8-26.8,7.7-30.7,3.8-5.7,3.8,21.1-3.8,28.8-3.8,46.1C82.5,496.6,81.3,520.4,80.8,530.4Z",
    style: {
      fill: "#325e93"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "wihiteshirt",
    d: "M140.1,226c0,5.8,1.9,11.5,0,19.2s-32.7-13.4-32.7-13.4l-5.7-13.5,1.9-3.8,11.5-1.9c1.9,0,3.8,5.7,7.7,7.7s5.7,5.7,9.6,5.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.2,262.6c-1,2.5-2,4.6-2.5,5.6-1.9,3.7-3.8,7.4-12.5,16.3l-1,1s-5.7,7.7-3.8-5.8,3.1-17.2,7.8-23.9l3.9,2.2a14.8,14.8,0,0,0-.1,2.1c0,2.6.9,1.5,2.4-.8s4.6-7.3,7.8-9.4S203.1,256.1,200.2,262.6Z",
    style: {
      fill: "#b7ceea"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.1,289.3l3.8-4.2-10.8,40a31.9,31.9,0,0,1-2.6,2.6c-11.5,11.6-21.1,13.5-21.1,13.5a8.8,8.8,0,0,0-2.8-.1,7,7,0,0,0-2,.8c-1.6,1-2.9,3-2.9,6.9,0,9.6,1.9,21.1,0,28.8-.1.6-.8.8-2,.8s-7.9-.8-13.3-.8c-7.7,0-21.1-3.8-26.9-7.7s-17-16.7-21.9-23.3L59.5,345c-3.9-5.8,1.8-21.1,5.7-28.8s9.6-13.4,11.5-23c0,0-1.9-40.3,0-53.8s5.8-24.9,13.5-28.8,11.5-3.8,23,0c2.3.8,3.8,2.3,3.9,3.5h0c.2,1.9-2.1,3.4-7.7,2.3-1.9-.4-3.9,1.9-3.9,5.7s5.8,9.6,9.6,13.5,9.6,5.7,15.4,5.7c3.8,0,7.7-3.4,10.4-5.1s2.4-1.3,3-.6,7.7,13.4,7.7,17.2v28.8c0,9.6-1.9,21.2-1.9,23.1S157.8,295.5,163.1,289.3Z",
    style: {
      fill: "#5ba2ce"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.1,287.4c0,1.9-3.8,5.8-3.8,5.8-2.1,2.8-5,6.7-8.4,11l4.9-18.2a5.9,5.9,0,0,0-4.2-7.1h-.1c2.5-1.1,3.9-.1,5.9.9a11.4,11.4,0,0,1,4.8,4.7A5.2,5.2,0,0,1,186.1,287.4Z",
    style: {
      fill: "#5ba2ce"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "hair",
    d: "M159.3,191.5c1.9-5.8,5.7-7.7,3.8-11.6s1.9-3.8-5.8-7.6-11.5-5.8-17.2-5.8-15.4,0-19.2,3.8-5.8,13.5-5.8,21.2,1.9,19.1,3.8,26.8,30.8-3.8,32.7-9.6S159.3,191.5,159.3,191.5Z",
    style: {
      fill: "#264860"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "head",
    d: "M161.2,185.7c0,5.8,1.9,7.7,0,17.3s-5.8,13.4-7.7,17.2-11.5,0-11.5,3.9-1.9,5.7-1.9,5.7a8.5,8.5,0,0,1-5.8,2s-1.9,0-5.8-2-5.7-1.8-7.6-3.8-3.9-1.9-5.8-5.8c-.4-.7,2.7-3.2,3.9-3.8,3.8-1.9,3.8-1.9,5.7,0s1.9,1.9,5.6.1a4.5,4.5,0,0,0,2.1-5.9h0c-1.9-3.8-1.9-7.6,1.9-7.6s3.8,3.8,3.8,5.7,2,1.9,3.9-5.7,3.8-11.5,5.7-13.5,2-3.8,5.8-3.8Z",
    style: {
      fill: "#b7ceea"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.8,272.1c-3.8,13.4-5.8,23-5.8,30.7s-1.9,24.9,1.9,30.7a28.7,28.7,0,0,0,8.6,8.4l4.9-.7s-9.6,1.9-9.6-11.5,1.8-26.9,1.8-34.6S122.8,272.1,122.8,272.1Z",
    style: {
      fill: "#5e8faa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "note"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M242.1,210.6l-12.4,42.5a3.6,3.6,0,0,1-1.9,2.1l-16.9,6.9-5.2,2.1h-.3a3.9,3.9,0,0,1-2.6-.2l-2.5-1.5-5.8-3.2-2.4-1.4c.5-5.3,2.5-10.8-2.6-4-.4.6-.9,1.2-1.3,1.9l-29.1-16.5c-.5-.2-.6-.9-.4-1.6l18.2-62.5c.3-1.2,1.5-2,2.2-1.6L241.8,209A1.4,1.4,0,0,1,242.1,210.6Z",
    style: {
      fill: "#3b79bc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "DISPALY_CONTENT-15",
    "data-name": "DISPALY CONTENT-15",
    d: "M205.7,264.2c-.8.3-1.3-.1-1.1-1l5.2-17.7c.2-.8,1.6-1,2.7-.4l15.3,8.6c.8.5.8,1.2-.1,1.5Z",
    style: {
      fill: "#376c9b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "DISPALY_CONTENT-16",
    "data-name": "DISPALY CONTENT-16",
    d: "M225.6,216l-43-24.2a2.2,2.2,0,0,1-1-2.7h0a2.2,2.2,0,0,1,2.8-1.4h.5l42.9,24.3a2.2,2.2,0,0,1,1.1,2.7h0a2.3,2.3,0,0,1-2.9,1.4Z",
    style: {
      fill: "#2b517f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "DISPALY_CONTENT-17",
    "data-name": "DISPALY CONTENT-17",
    d: "M213.2,221.9l-34.9-19.7a1.9,1.9,0,0,1-.6-2.5h0a2.1,2.1,0,0,1,2.9-1.4l34.8,19.6a2,2,0,0,1,.7,2.6h0A2.1,2.1,0,0,1,213.2,221.9Z",
    style: {
      fill: "#2b517f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "DISPALY_CONTENT-18",
    "data-name": "DISPALY CONTENT-18",
    d: "M194,238.3,170.5,225c-.5-.3-.6-1.2-.2-2.2h0c.6-1.2,1.7-2.1,2.4-1.7l23.5,13.2c.5.3.6,1.2.2,2.2h0C195.8,237.8,194.7,238.6,194,238.3Z",
    style: {
      fill: "#2b517f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "DISPALY_CONTENT-19",
    "data-name": "DISPALY CONTENT-19",
    d: "M217.9,238.1l-43-24.3a2.2,2.2,0,0,1-1-2.7h0a2.2,2.2,0,0,1,2.8-1.4l.5.2,42.9,24.2a2.3,2.3,0,0,1,1.1,2.7h0a2.3,2.3,0,0,1-2.9,1.4Z",
    style: {
      fill: "#2b517f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M156.1,325.1c6.4-6.7,12.6-14.3,17.8-20.8l-59.3,220-5.5,20.4L91.7,609.1A5.9,5.9,0,0,1,80.4,606l14.9-55.2,3.2-12,1.6-5.9,9.2-34.2Z",
    style: {
      fill: "#6e8ea0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.9,285.1l.6-2.1a5.8,5.8,0,0,1,5.6-4.3h1.4C172.7,279.6,170.4,281.4,166.9,285.1Z",
    style: {
      fill: "#6e8ea0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "finger",
    d: "M192.1,258l-3.9-2.2c.4-.6.9-1.2,1.3-1.9C194.6,247.2,192.6,252.7,192.1,258Z",
    style: {
      fill: "#b7ceea"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "slave",
    d: "M178.8,286l-4.9,18.2c-5.2,6.6-11.4,14.1-17.8,20.8l10.8-39.9c3.5-3.7,5.8-5.5,7.6-6.3h.1A5.9,5.9,0,0,1,178.8,286Z",
    style: {
      fill: "#5ba2ce"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorksFigNobg);
export default __webpack_public_path__ + "static/media/works_fig_nobg.6675d88a485f9fae63d8809deec03250.svg";
export { ForwardRef as ReactComponent };